import get from 'lodash/get';

import { DISTRIBUTOR } from '@autopass-web/domain';

import { DIST } from '../config';
import storage from '../service/storage';

export const getLoginState = () => {
  const scopes = get(storage.getAuth(), 'scopes', null);
  const skipLogin = storage.getSkipLogin();

  switch (DIST) {
    case DISTRIBUTOR.RICHART_LIFE:
      return 'user';
    // return storage.getRichartLifeIsBinded() ? 'user' : 'none';
    case DISTRIBUTOR.IKNOW99:
      return storage.getIknow99IsBinded() ? 'user' : 'none';
    case DISTRIBUTOR.LINE_BANK:
      return storage.getLineBankIsBinded() ? 'user' : 'none';
    default:
      if (scopes) {
        switch (scopes) {
          case 'update_user_info':
            return 'register';
          default:
            return 'user';
        }
      } else {
        if (skipLogin) {
          return 'skip';
        } else {
          return 'none';
        }
      }
  }
};
